export const titleMotion = {
    initial: {
        opacity: 0,
        y: 20,
    },
    animate: {
       opacity: 1,
       y: 0,
       transition: {
            delay: .2,
            ease: [0.99, 0.15, 0, 0.86],
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .5
        }
    }
}

export const buttonContainerMotion = {
    initial: {},
    animate: {
        transition: {
            staggerChildren: .2,
            delayChildren: 1.2,
        }
    },
    exit: {}
}

export const buttonMotion = {
    initial: {
        opacity: 0,
        y: 10,
    },
    animate: {
       opacity: 1,
       y: 0,
       transition: {
           ease: [0.99, 0.15, 0, 0.86],
       }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .5
        }
    }
}